import React, { TouchEvent, useCallback, useContext, useState } from "react"
import SelectSyainCode from "../../../../components/Tablet/SelectSyainCode"
import { AppDispatch } from "../../../.."
import { useDispatch } from "react-redux"
import { clearAlert, setAlerts } from "../../../../globalStore/alertStore"
import { ModalOuter } from "../../../../components/Tablet/ModalOuter"
import truckMan from "../../../../source/img/takuhai_truck_man.png"
import { CSS_PROPERTY } from "../../cssProperties/tablet"
import ZyomuinService from "../../../../service/driver/zyomuinService"
import { TZyomuinGetRes } from "../../../../service/driver/TZyomuin"
import { useHistory } from "react-router-dom"
import { selectTenkoTimingPage } from "../../../../constant/tablet/pages"
import { ZyomuinContext } from "../../context/context"
import { showWarnToast } from "../../../../components/Tablet/TabletToast"

const SelectZyomuinByNumber = React.memo(() => {
  const dispatch: AppDispatch = useDispatch()
  const history = useHistory()
  const { set乗務員 } = useContext(ZyomuinContext)

  const [乗務員コード, set乗務員コードState] = useState<string | undefined>("")
  const [乗務員Inner, set乗務員Inner] = useState<TZyomuinGetRes>()
  const [modalShow, setModalShow] = useState(false)

  const set乗務員コード = (value: string | undefined) => {
    if (value == null || value.length > 4) return
    set乗務員コードState(value)
  }

  const select社員Handler: (event: TouchEvent<HTMLDivElement>) => void =
    useCallback(
      async (e) => {
        dispatch(clearAlert())

        try {
          const res = await new ZyomuinService().getList({
            社員コード: 乗務員コード,
            社員コード完全一致フラグ: true,
          })

          if (res && res.data && res.data.length === 1) {
            const 乗務員Res = await new ZyomuinService().get(
              res.data[0].乗務員ID
            )
            if (乗務員Res) {
              set乗務員Inner(乗務員Res.data)
              setModalShow(true)
            } else {
              showWarnToast("乗務員コードと一致する乗務員が見つかりません")
            }
          } else {
            showWarnToast("乗務員コードと一致する乗務員が見つかりません")
          }
        } catch (error) {
          dispatch(setAlerts(error))
        }
      },
      [dispatch, 乗務員コード]
    )

  const cancel: (event: TouchEvent<HTMLDivElement>) => void = () => {
    set乗務員コードState("")
    set乗務員Inner(undefined)
    setModalShow(false)
  }

  const move時点選択: (event: TouchEvent<HTMLDivElement>) => void = (e) => {
    //モーダルクリックの貫通防止
    e.preventDefault()
    e.stopPropagation()
    set乗務員(乗務員Inner)
    history.push(selectTenkoTimingPage.Route.path)
  }

  return (
    <>
      <SelectSyainCode
        value={乗務員コード}
        setValue={set乗務員コード}
        onSubmit={select社員Handler}></SelectSyainCode>
      <ModalOuter
        isShow={modalShow}
        dialogClassName="w-75"
        setIsShow={setModalShow}>
        <table style={{ height: "40rem", width: "100%" }}>
          <tbody>
            <tr>
              <td
                colSpan={2}
                className="text-center"
                style={{ fontSize: "3rem" }}>
                以下の乗務員の点呼を開始します。よろしいですか？
              </td>
            </tr>
            <tr>
              <td colSpan={2} className="text-center align-middle my-3">
                <table className="d-inline-block">
                  <tbody>
                    <tr>
                      <td>
                        <div
                          className="text-end align-middle"
                          style={{
                            height: "20rem",
                            width: "100%",
                            backgroundColor: "white",
                          }}>
                          <img
                            src={truckMan}
                            style={{
                              height: "100%",
                              width: "auto",
                            }}
                            alt=""></img>
                        </div>
                      </td>
                      <td className="text-center" style={{ fontSize: "5rem" }}>
                        <table>
                          <tbody>
                            <tr>
                              <td className="text-end">
                                {乗務員Inner?.部所コード}
                              </td>
                              <td>:</td>
                              <td className="text-start">
                                {乗務員Inner?.部所略称}
                              </td>
                            </tr>
                            <tr>
                              <td className="text-end">
                                {乗務員Inner?.社員コード}
                              </td>
                              <td>:</td>
                              <td className="text-start">
                                {乗務員Inner?.社員氏名}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr className="text-center" style={{ fontSize: "4rem" }}>
              <td className="w-50">
                {" "}
                <div
                  className="d-inline-block"
                  onTouchStart={cancel}
                  style={{
                    bottom: "0",
                    backgroundColor: CSS_PROPERTY.OK_COLOR,
                    color: "white",
                    width: "25rem",
                    textAlign: "center",
                    ...CSS_PROPERTY.BORER_PROPERTIES,
                    marginBottom: "1rem",
                    padding: "0.5rem 1rem",
                  }}>
                  <span>再入力</span>
                </div>
              </td>
              <td className="w-50">
                <div
                  className="d-inline-block"
                  onTouchStart={move時点選択}
                  style={{
                    bottom: "0",
                    backgroundColor: CSS_PROPERTY.WARN_COLOR,
                    color: "white",
                    width: "25rem",
                    textAlign: "center",
                    ...CSS_PROPERTY.BORER_PROPERTIES,
                    marginBottom: "1rem",
                    padding: "0.5rem 1rem",
                  }}>
                  <span>確定</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </ModalOuter>
    </>
  )
})

export default SelectZyomuinByNumber
